import request from '../utils/request.js'

export default {
  // 获取增值包列表
  getLists (params) {
    return request.post(`addon/lists`, params).then(res => res.data)
  },
  // 获取企业增值包使用情况
  getUsage (params) {
    return request.post(`addon/usage`, params).then(res => res.data)
  },
  // 获取企业已购买的增值包列表
  getPurchased (params) {
    return request.post(`addon/purchased`, params).then(res => res.data)
  },
  // 购买增值包
  purchase (params) {
    return request.post(`addon/purchase`, params).then(res => res.data)
  },
  // 使用增值包配额
  useQuota (params) {
    return request.post(`addon/useQuota`, params).then(res => res.data)
  },
  // 获取增值包详情
  getDetail (params) {
    return request.post(`addon/detail`, params).then(res => res.data)
  },
  // 获取增值包统计信息
  getStatistics (params) {
    return request.post(`addon/statistics`, params).then(res => res.data)
  },
  // 更新过期状态
  updateExpiredStatus (params) {
    return request.post(`addon/updateExpiredStatus`, params).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/addon.js